import {Component, DoCheck} from '@angular/core';
import {Utils} from './shared/utils';
import {VERSAO} from './constante';

// Add the RxJS Observable operators.
import './rxjs-operators';
import {AppService} from './app.service';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {AcessoService} from "./acesso/acesso.service";
import {ActivatedRoute, Route, Router} from "@angular/router";
import {UsuarioService} from "./usuario/usuario.service";
import {PerfilService} from "./perfil/perfil.service";
import {EventosService} from "./eventos/eventos.service";
import {DatePipe} from "@angular/common";
import {Title} from "@angular/platform-browser";
import {RecuperarSenhaService} from "./recuperar-senha/recuperar-senha.service";
import {FlashMessagesService} from "angular2-flash-messages";
import {QuestionService} from "./question/question.service";
import {TrabalhoService} from "./trabalho/trabalho.service";
import {AvaliacaoService} from "./avaliacao/avaliacao.service";
import {InscricaoService} from "./inscricao/inscricao.service";
import {CategoriaCientificaService} from "./categoria_cientifica/categoria_cientifica.service";
import {CadastroService} from "./cadastro/cadastro.service";
import {FormacaoService} from "./formocao/formacao.service";
import {ReportService} from "./report/report.service";
import {ConfigService} from './config/config.service';
import {RecursoService} from './pedir-recurso/recurso.service';
import {Trabalho} from "./trabalho/trabalho";
import {CertificadoService} from './certificado/certificado.service';
import {PenalidadeService} from './penalidade/penalidade.service';

declare var jQuery: any;


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers: [AcessoService,
        UsuarioService,
        PerfilService,
        EventosService,
        DatePipe,
        RecuperarSenhaService,
        QuestionService,
        TrabalhoService,
        AvaliacaoService,
        InscricaoService,
        CategoriaCientificaService,
        CadastroService,
        FormacaoService,
        ReportService,
        AppService, 
		ConfigService,
		RecursoService,
		CertificadoService,
		PenalidadeService, 		
    ]
})

export class AppComponent implements DoCheck {
    title = 'DECULT';
    version = VERSAO;
    apptoken = "";
    user_name = "";
    perfil = '';
    user_id: any;
    routeactive: any;
    hash: string;
    url:string="";
	model: any;
	service = this.appService;
	id: number;
	ano: number = new Date().getFullYear();

    constructor(protected acessoService: AcessoService,
                protected router: Router,
                protected inscricaoService: InscricaoService,
                protected avaliacaoService: AvaliacaoService,
                protected trabalhoService: TrabalhoService,
                protected usuarioService: UsuarioService,
                protected perfilService: PerfilService,
                protected categoriaCientificaService: CategoriaCientificaService,
                protected formacaoService: FormacaoService,
                protected cadastroService: CadastroService,
                protected route: ActivatedRoute,
                protected recSenhaService: RecuperarSenhaService,
                protected eventoService: EventosService,
                protected questionService:QuestionService,
                protected flashMessagesService: FlashMessagesService,
				protected spinnerService: Ng4LoadingSpinnerService,
                protected datePipe: DatePipe,
                protected reportService: ReportService,
                protected titleService: Title,
				protected appService: AppService,
				protected configService: ConfigService,
				protected recursoService: RecursoService,
				protected certificadoService: CertificadoService,
				protected penalidadeService: PenalidadeService,
				public utils: Utils) {
        this.user_id = this.acessoService.getUsuario().id;
		this.titleService.setTitle(this.title);
    }

	ngDoCheck(): void {
        let title = 'DECULT';

        if (title !== this.title) {
            this.titleService.setTitle(this.title);

            // this.changeDetected = true;
            // this.changeLog.push(`DoCheck: Hero name changed to "${this.hero.name}" from "${this.oldHeroName}"`);
            // this.oldHeroName = this.hero.name;
        }
    }
	
    validar_login(){
        if (!this.islogged()) {
            this.router.navigateByUrl('acesso');
        }
    }


    isAdmin() {
        try {
            if (parseInt(sessionStorage.getItem('perfil')) == 3) {
                return true;
            }

        } catch (err) {
            return false;
        }
    }

	get() {
        this.service.get().then(response => this.model = response);
    }
	
	show(id) {
        this.service.show(id).then(response => this.model = response);
    }
	
	delete(id) {
        this.service.delete(id).then(response => this.goBack());
    }
	
	submit(model) {
        this.service.save(model).then(response => this.goBack());
    }
	
	update(model) {
        this.service.update(model).then(response => this.goBack());
    }
	
	settitle(title) {
        this.titleService.setTitle(title);
    }
	
    isParecerista() {
        try {
            if (parseInt(sessionStorage.getItem('perfil')) == 2) {
                return true;
            }

        } catch (err) {
            return false;
        }
    }

    islogged() {
        this.apptoken = sessionStorage.getItem('api_token');
        this.user_name = sessionStorage.getItem('nome');

        let apptoken = sessionStorage.getItem('api_token');
        if (apptoken) {
            return true
        } else
            return false;
    }

    sair() {
        localStorage.clear();
        sessionStorage.clear();
    }

    goBack(): void {
        // this.router.navigate(['/evento-list']);
        window.history.back();
    }
	
	setEtapas(trabalho: Trabalho, etapas: any): void {
		let datas_ini: any[] = [];
		let datas_fim: any[] = [];
		let numEtapas: number = etapas.length;
		let i: number = -1;
		let dataIni: string;
		let dataFim: string;
		
		while (++i < numEtapas) {
			dataIni = etapas[i].data_ini;
			dataFim = etapas[i].data_fim;
			datas_ini.push({date: {year: dataIni.substring(0, 4), month: parseInt(dataIni.substring(5, 7)), 
																  day: parseInt(dataIni.substring(8, 10))}});
			datas_fim.push({date: {year: dataFim.substring(0, 4), month: parseInt(dataFim.substring(5, 7)), 
															      day: parseInt(dataFim.substring(8, 10))}});
		}
		
		trabalho.datas_ini = datas_ini;
		trabalho.datas_fim = datas_fim;
		
		if (trabalho.inicio_evento) {
			trabalho.inicio_evento = this.datePipe.transform(trabalho.inicio_evento, 'yyyy-MM-ddTHH:mm');
			trabalho.fim_evento = this.datePipe.transform(trabalho.fim_evento, 'yyyy-MM-ddTHH:mm');
		}
	}

    sortTable(n) {
        var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
        table = document.getElementById("tblExport");
        switching = true;
        //Set the sorting direction to ascending:
        dir = "asc";
        /*Make a loop that will continue until
        no switching has been done:*/
        while (switching) {
            //start by saying: no switching is done:
            switching = false;
            rows = table.getElementsByTagName("TR");
            /*Loop through all table rows (except the
            first, which contains table headers):*/
            for (i = 1; i < (rows.length - 1); i++) {
                //start by saying there should be no switching:
                shouldSwitch = false;
                /*Get the two elements you want to compare,
                one from current row and one from the next:*/
                x = rows[i].getElementsByTagName("TD")[n];
				if (x.getElementsByTagName("a").length > 0)
					x = x.getElementsByTagName("a")[0];
                y = rows[i + 1].getElementsByTagName("TD")[n];
				if (y.getElementsByTagName("a").length > 0)
					y = y.getElementsByTagName("a")[0];
                /*check if the two rows should switch place,
                based on the direction, asc or desc:*/
                if (dir == "asc") {
                    if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                        //if so, mark as a switch and break the loop:
						shouldSwitch = true;
                        break;
                    }
                } else if (dir == "desc") {
                    if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                        //if so, mark as a switch and break the loop:
                        shouldSwitch = true;
                        break;
                    }
                }
            }
            if (shouldSwitch) {
                /*If a switch has been marked, make the switch
                and mark that a switch has been done:*/
                rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
                switching = true;
                //Each time a switch is done, increase this count by 1:
                switchcount++;
            } else {
                /*If no switching has been done AND the direction is "asc",
                set the direction to "desc" and run the while loop again.*/
                if (switchcount == 0 && dir == "asc") {
                    dir = "desc";
                    switching = true;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts